export const CORONA_NINJA_BASE_URL = 'https://corona.lmao.ninja/v2';
// export const NEWS_BASE_URL = 'http://localhost:8080/api/covid-19-news';
export const NEWS_BASE_URL = 'https://amyspeed-backend.herokuapp.com/api/covid-19-news';